import React from "react";

interface BallotIconProps {
  size?: number;
  color?: string;
}

export default function BallotIcon({ size = 16, color = "#666" }: BallotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3z"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M5 6h6M5 8h6M5 10h4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}